module.exports = __webpack_public_path__ + "static/img/big-bg2.1a4921ab.png";